import { ReactElement } from 'react';
import { Button, DialogActions } from '@mui/material';

import { CommonDialogActionsProps } from '../types';
import ProgressButton from '../ProgressButton';

type ContentModalActionsProps = CommonDialogActionsProps & {
  /**
   * Function to close the modal (used for both cancel and close button).
   */
  onClose?: () => void;

  /**
   * Function to call on confirm action
   * Ignored if not provided.
   */
  onConfirm?: (...args: unknown[]) => unknown;
};

/**
 * A reusable dialog actions component with "Confirm" and "Cancel" buttons for modals.
 *
 * To be used inside `ButtonWithDialog` when `hideDialogActions` is true
 * and custom action buttons need to be displayed manually.
 */
export const ContentModalActions = ({
  confirmButtonText,
  confirmButtonProps,
  cancelButtonText = 'Cancel',
  disableConfirmButton,
  onClose,
  onConfirm,
}: ContentModalActionsProps): ReactElement => {
  return (
    <DialogActions sx={{ padding: 0 }}>
      {onClose && (
        <Button onClick={onClose} variant="outlined" disableElevation>
          {cancelButtonText}
        </Button>
      )}
      {(onConfirm || confirmButtonProps?.type === 'submit') && (
        <ProgressButton
          color="primary"
          variant="contained"
          disabled={disableConfirmButton}
          disableElevation
          onClick={onConfirm}
          {...confirmButtonProps}
        >
          {confirmButtonText || 'Confirm'}
        </ProgressButton>
      )}
    </DialogActions>
  );
};
